"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationFinancialActivity_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LocationFinancialActivity_Factory = /** @class */ (function () {
    function LocationFinancialActivity_Factory() {
    }
    LocationFinancialActivity_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Collections: model.Collections,
            Month: model.Month,
            Productions: model.Productions,
            Year: model.Year,
        };
        return result;
    };
    LocationFinancialActivity_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Collections: model.Collections,
            Month: model.Month,
            Productions: model.Productions,
            Year: model.Year,
        };
        return result;
    };
    return LocationFinancialActivity_Factory;
}());
exports.LocationFinancialActivity_Factory = LocationFinancialActivity_Factory;
